module.exports = __webpack_public_path__ + "img/dotcom-seance-logo-1-mobile.2ad012fd.svg";